import { render } from "./App.vue?vue&type=template&id=2f1108f5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2f1108f5&lang=scss"

import exportComponent from "/Applications/phpstudy/bjhy/t.sz.edu-xr-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__